baseApp.directive('clickableInput', function() {
	return{
		templateUrl: '/public/directives/clickableInput.html',
		scope: {
			paramToEdit: '=',
			placeHolder: '@',
		},
		link: function($scope, element) {
			$scope.$el = $(element[0]);
		},
		controller: ['$scope', '$timeout', function($scope, $timeout) {
			$scope.focusOnInput = function() {
				$timeout(function() {
					$scope.$el.find('input').focus();
				}, 0, false);
			}
		}],
	}
});